<script lang="ts">
	import { styleObject } from '@vpap_svelte/internal';
	import { ActiveLayer, HtmlManager } from './Managers.svelte.js';

	import type { HTMLElementProps } from '@vpap_svelte/internal';
	import type { Snippet } from 'svelte';

	interface HTMLProps extends Omit<HTMLElementProps<HTMLDivElement>, 'children'> {
		/**
		 * The child snippet, with context
		 */
		children?: Snippet<[HtmlManager]>;
		/**
		 * Whether the element is designed to be used in `ssr` contexts
		 * @default false
		 */
		ssr?: boolean;
	}

	let { children, ssr = false, style, ...attrs }: HTMLProps = $props();
	let element: HTMLDivElement | undefined = $state(undefined);
	let styleStr = $derived(styleObject(style ?? {}));

	let manager = new HtmlManager({ element: () => element, ssr: () => ssr });
	ActiveLayer.set(manager);
</script>

<div bind:this={element} style={styleStr} {...attrs}>
	{#if children}
		{@render children(manager)}
	{/if}
</div>

<style>
	div {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
	}
</style>
